module.exports = __webpack_public_path__ + "logo.png?2c2616b46a948bcd94a7b75f2441e13e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 55
// module chunks = 0